import styles from "./PricePromise.module.scss";
import { StandardProps } from "../componentMap";
import { IconButton } from "@JohnLewisPartnership/jl-design-system/dist/elements/button/IconButton";
import { InfoOutlined } from "@JohnLewisPartnership/jl-design-system/dist/components/icons/InfoOutlined";
import { CloseOutlined } from "@JohnLewisPartnership/jl-design-system/dist/components/icons/CloseOutlined";
import { useState } from "react";
import { GreenPoundSvg } from "@/components/PricePromise/GreenPoundSvg.tsx";
import { GreenTickSvg } from "@/components/PricePromise/GreenTickSvg.tsx";
import { recordImpressionByParam } from "@JohnLewisPartnership/experiments-utils";

export const PricePromise = ({
  product,
  flags,
  runtimeConfig,
  experiencesRawObject,
}: Pick<
  StandardProps,
  "product" | "flags" | "runtimeConfig" | "experiencesRawObject"
>) => {
  const pricePromiseVersion =
    flags && flags.showPricePromise && flags.showPricePromise.value;
  const [showPricePromiseTooltip, setShowPricePromiseTooltip] = useState(false);

  const hasExclusiveAdditional = product?.messaging?.some(
    (msg) =>
      msg.type === "additional" &&
      typeof msg.title === "string" &&
      msg.title.toLowerCase().includes("exclusive"),
  );

  if (
    hasExclusiveAdditional ||
    !pricePromiseVersion ||
    (pricePromiseVersion != "variant1" && pricePromiseVersion != "variant2")
  )
    return null;

  return (
    <div
      className={styles.pricePromiseContainer}
      data-testid="price-promise-container"
    >
      <div className={styles.pricePromiseInfoContainer}>
        {pricePromiseVersion == "variant1" ? (
          <GreenPoundSvg />
        ) : (
          <GreenTickSvg />
        )}
        <p className={styles.pricePromiseMessage}>
          {pricePromiseVersion == "variant1"
            ? "Our price promise"
            : "Price matched"}
        </p>

        <IconButton
          IconComponent={InfoOutlined}
          ariaLabel="Info Button"
          onClick={() => {
            !showPricePromiseTooltip
              ? setShowPricePromiseTooltip(true)
              : setShowPricePromiseTooltip(false);

            if (!showPricePromiseTooltip) {
              recordImpressionByParam(
                runtimeConfig?.monetateEnvironment,
                experiencesRawObject as [],
                "pdp-scaffold-openPricePromiseObservation",
                "true",
              );
            }
          }}
          size="small"
          variant="clear-dark"
          className={styles.pricePromiseButton}
          data-testid="price-promise-info-button"
        />
      </div>
      {showPricePromiseTooltip && (
        <div
          className={styles.pricePromiseTooltipContainer}
          data-testid="price-promise-tooltip-container"
        >
          <p
            className={styles.pricePromiseTooltipMessage}
            data-testid="price-promise-tooltip-message"
          >
            We match the price of this item and thousands more with 25 top
            retailers. If the price drops within 7 days of purchase,&nbsp;
            <a
              target="_blank"
              href="https://www.johnlewis.com/customer-services/prices-and-payment/price-promise?source=pricepromisetooltip"
              rel="noreferrer"
              data-testid="price-promise-tooltip-link"
            >
              claim back the difference.
            </a>
          </p>
          <IconButton
            IconComponent={CloseOutlined}
            ariaLabel="Close Button"
            onClick={() => setShowPricePromiseTooltip(false)}
            size="small"
            variant="clear-dark"
            className={styles.pricePromiseButton}
            data-testid="price-promise-close-button"
          />
        </div>
      )}
    </div>
  );
};
